












import Vue from 'vue';
import FloatButton from "./components/FloatButton.vue";
import License from "./components/License.vue"
// import Header from '@/components/Header.vue'
import axios from 'axios'

export default Vue.extend({
  name: 'App',
  components: {FloatButton,License},
  data: () => ({
    drow:false,
    connected:false,
    withsidemenu:true,
  }),

  computed: {
      lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
  },

  methods:{
    getStart(){
      let pp = new FormData();
      pp.append('defBranch',localStorage.getItem('defBranch'));
      pp.append('financeYear',localStorage.getItem('financeYear'));
      let type = 'getMeTodo';
      pp.append('type',type);
      axios.post(
          this.$store.state.SAMCOTEC.r_path
          ,pp
      ).then((response) => {
          this.$store.commit('setLicenseType',response.data.results.data);
          this.$store.state.redirectURl = response.data.results.loginRedirect;
          localStorage.setItem('_ECar_',JSON.stringify(response.data.results.data));
          localStorage.setItem('redirectURl',JSON.stringify(response.data.results.redirectURl));

      })

    },
    handleUpdate: function () {
      //this.connected = true;
    },
    getCookies(){
      if(this.connected == true) return false;
      let x = this.$cookies.get(this.$store.state.COOKIEPhase);
      if(x == null){

        this.connected = false;
        if(this.$route.name != 'Login')
          this.$router.push({name: "Login"})
      }
      else{
        this.connected = true;
        if(this.$route.name == 'Login')
          this.$router.push({name: 'Home'});
      }
    },
    checkLicense(){
      axios.get(
        this.$store.state.SAMCOTEC.r_path
      ).then( (response) => {

        const res = response.data;
        if(res.error.number == 555){
          // document.getElementById('apply_license').style.display = "block";
          // this.license = res.results.data[1];
          // this.settings = res.results.data[0];
        }
      })
    },

  },
  created() {
    setTimeout(() => {this.getStart();},1000);
    document.title = this.$store.state.SystemName;
    //this.getCookies()
  },
});
